export default __webpack_public_path__ + "static/media/medsure-circle.458cd803.png";